import React, { ReactElement } from "react";
import Popover from "@/component/Popover";
import Switch from "@/component/Switch";
import fridayReporter from "@/utils/friday";
interface IProps {
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  skipBlank: boolean;
  children: ReactElement;
  setSkipBlank: (skipBlank: boolean) => void;
}

const MorePanel: React.FC<IProps> = ({ visible, setVisible, skipBlank, children, setSkipBlank }) => {
  const handleChangeSkipBlank = (skipBlank: boolean) => {
    setSkipBlank(skipBlank);
    if(skipBlank){
      fridayReporter.pushData({
        eventCode: 'SummaryPage_Play_SkipBlank'
      })
    }
  };

  const content = (
    <div className="flex items-center justify-center w-34 h-8 text-mx-secondary text-3.5 line-height-5.5">
      跳过空白片段
      <Switch className="ml-2" checked={skipBlank} size="small" onChange={handleChangeSkipBlank} />
    </div>
  );

  return (
    <Popover visible={visible} setVisible={setVisible} content={content} placement="topRight">
      {children}
    </Popover>
  );
};

export default MorePanel;
